import { useLayoutEffect } from 'react';
import {
  type TranslationNode,
  useInlineTranslation,
} from '@/i18n/hooks/useInlineTranslation';

export function useDocumentTitle(
  heading: TranslationNode,
  subheading?: TranslationNode,
) {
  const { text } = useInlineTranslation();

  useLayoutEffect(() => {
    // Specific part first: a browser tab truncates the end, not the start.
    const page = text(subheading) || text(heading);
    const area = subheading ? ` – ${text(heading)}` : '';

    document.title = `${page}${area} | Eye-Able Dashboard`;
  }, [text, heading, subheading]);
}
